/* eslint-disable jsx-a11y/scope */
/* eslint-disable no-dupe-keys */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import Content from "../../../layout/content/Content";
import { Card, Spinner, FormGroup } from "reactstrap";
import { Button, Block, Row, Col, Icon } from "../../../components/Component";
import Swal from "sweetalert2";
import Head from "../../../layout/head/Head";
import ES3Update from "./ES3Update";
import { DownloadTableExcel } from "react-export-table-to-excel";
import OptionCDisable from "../../components/DynmicOption/OptionCDisable.";
import * as xlsx from "xlsx";
import "./Pageloading.css";
const ES3DataEdit = ({ ...props }) => {
  const [dataactive, setdataactive] = useState([]);
  const [Totall, setTotal] = useState([]);
  const [Change, setchange] = useState(true);
  const [Gloading, setGloading] = useState(false);
  const [GTotal, setGTotal] = useState(0);
  const [Countdata, setCountdata] = useState(0);
  const [userData, setuserData] = useState("");
  const month1 = [
    "Test",
    "JANUARY",
    "FEBRUARY",
    "MARCH",
    "APRIL",
    "MAY",
    "JUNE",
    "JULY",
    "AUGUST",
    "SEPTEMBER",
    "OCTOBER",
    "NOVEMBER",
    "DECEMBER",
  ];
  const [employmentId, setemloymentId] = useState(
    sessionStorage.getItem("employmentId")
  );
  const today = new Date();
  const tableRef = useRef(null);
  const tableRef1 = useRef(null);
  const [Draft, setDraft] = useState(true);
  const [loading, setloading] = useState(false);
  const [exportloading, setexportloading] = useState(false);
  const [formData, setFormData] = useState({
    EmploymentId: Number(props.employmentId),
    UserId: Number(localStorage.getItem("userId")),
    ParametersId: Number(props.parametersId),
    month:
      sessionStorage.getItem("CurrentMonth") === null
        ? today.getMonth() === 0
          ? 12
          : today.getMonth()
        : sessionStorage.getItem("CurrentMonth"),
    dummymonth:
      sessionStorage.getItem("CurrentMonth") === null
        ? month1[today.getMonth()]
        : month1[sessionStorage.getItem("CurrentMonth")],
    year:
      sessionStorage.getItem("CurrentYear") === null
        ? today.getMonth() === 0
          ? today.getFullYear() - 1
          : today.getFullYear()
        : sessionStorage.getItem("CurrentYear"),
    EmploymentRefId: sessionStorage.getItem("EmploymentRefId"),
  });
  const inputRef = useRef(null);

  const handleClick = () => {
    // 👇️ open file input box on click of another element
    inputRef.current.click();
  };

  const onInputChange = (month, year) => {
    setFormData({ ...formData, month: month, year: year });
  };
  const Total = async (empId) => {
    const sendData = {
      EmploymentId: Number(empId),
    };
      // //console.log(sendData)
      const startTime = performance.now();

    await fetch(
      process.env.REACT_APP_API_LINK + "api/Data/GetES3DetailsTotal1",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(sendData),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        setTotal(data[0]);
      });
      // End timer
      const endTime = performance.now();

      const responseTime = endTime - startTime;

      console.log(
          "GetES3DetailsTotal1 API Response Time:",
          responseTime.toFixed(2),
          "ms"
      );

      console.log(
          "GetES3DetailsTotal1 API Response Time:",
          (responseTime / 1000).toFixed(2),
          "seconds"
      );
  };
  const getdata2 = async (emp) => {
    const sendData = {
      EmploymentId: Number(emp),
    };

    await fetch(process.env.REACT_APP_API_LINK + "api/Main/GetEs3param", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(sendData),
    })
      .then((response) => response.json())
      .then((data) => {
        ////console.log(data)
        setdataactive(data);
        setCountdata(data.length);
      });
  };
  const getdata = async () => {
    const sendData = {
      EmploymentId: Number(employmentId),
      UserId: Number(localStorage.getItem("userId")),
    };

    await fetch(process.env.REACT_APP_API_LINK + "api/Main/Viewalldata", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(sendData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data === "NO") {
          setloading(false);
          setDraft(true);
        } else {
          setloading(false);
          setDraft(false);
          setemloymentId(data.employmentId);
          getdata2(data.employmentId);
          Total(data.employmentId);
          setuserData(data);
        }
      });
  };
  const generate = async () => {
    if (formData.year > 0 && formData.month > 0) {
      setloading(false);
      setGloading(true);
      const sendData = {
        UserId: Number(localStorage.getItem("userId")),
        EmploymentRefId: Number(formData.EmploymentRefId),
        YearId: Number(formData.year),
        MonthId: Number(formData.month),
      };
      //console.log(sendData)

      await fetch(process.env.REACT_APP_API_LINK + "api/Main/GenerateEs3", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(sendData),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data === "Error") {
            Swal.fire({
              title: " This Month Report is Already Submitted",
              icon: "error",
            });
          } else {
            setloading(false);
            setGloading(false);
            getdata();
          }
        });
    } else {
      Swal.fire({
        icon: "warning",
        title: "Month or Year Not Selected",
        text: "Please Select Month and Year",
        focusConfirm: false,
      }).then(() => {
        props.history.push("/Dashboard");
      });
    }
  };
  useEffect(() => {
    if (employmentId > 0) {
      Total(employmentId);
      setchange(!Change);
    }
  }, [GTotal]);
  useEffect(() => {
    setloading(true);
    getdata();
  }, []);
  const onFormSubmit = async () => {
    Swal.fire({
      title: "Are You Sure you want to Submit  ?",
      icon: "question",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Yes",
      confirmButtonColor: "success",
      denyButtonText: `No`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        const sendData = {
          EmploymentId: employmentId,
        };

        //console.log(sendData)
        await fetch(process.env.REACT_APP_API_LINK + "api/Main/Submitform", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(sendData),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data === "Done") {
              props.history.push("/Dashboard");
            } else {
              Swal.fire({
                title: "Data Not Submitted",
                icon: "error",
              });
            }
          });
      } else if (result.isDenied) {
        getdata();
      }
    });
  };

  const onSaveDraft = async () => {
    Swal.fire({
      title: "Data Saved Successfully",
      icon: "success",
    });
    getdata();
  };
  const onSaveDraftGoBack = async () => {
    Swal.fire({
      title: "Data Saved Successfully",
      icon: "success",
    });
    props.history.push("/Dashboard");
    getdata();
  };
  const ADDDynamic = async () => {
    setloading(false);
    const sendData = {
      EmploymentId: employmentId,
      EmploymentRefId: Number(formData.EmploymentRefId),
    };
    //console.log(sendData)

    await fetch(process.env.REACT_APP_API_LINK + "api/Main/DynamicAddEs3", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(sendData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data === "Done") {
          setloading(true);
          getdata();
        } else {
          window.location.reload();
        }
      });
  };

    //IMport Excel
    const readUploadFile = async (e) => {
        e.preventDefault();
        setexportloading(true)
        if (e.target.files) {
            const reader = new FileReader();
            reader.onload = async (e) => {
                const data = e.target.result;
                //console.log(data)
                const workbook = xlsx.read(data, { type: "array" });
                // //console.log(workbook)
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const json = xlsx.utils.sheet_to_json(worksheet);
                
                // Validate NCO codes before importing
                let hasInvalidNco = false;
                let invalidNcoMessage = '';
                
                for (let item of json) {
                    const ncoValue = String(item._8DigitNco20152).replace(/[^0-9Xx]/g, '');
                    if (ncoValue.length > 0 && ncoValue.length !== 8) {
                        hasInvalidNco = true;
                        if (ncoValue.length > 8) {
                            invalidNcoMessage = `Please verify the 8-character code and try again.`;
                        } else if (ncoValue.length < 8) {
                            invalidNcoMessage = `Please verify the 8-character code and try again.`;
                        }
                        break;
                    }
                }
                
                if (hasInvalidNco) {
                    setexportloading(false);
                    Swal.fire({
                        icon: 'warning',
                        title: 'Invalid NCO Code',
                        text: invalidNcoMessage,
                        confirmButtonText: 'OK'
                    });
                    return;
                }
                
                // Filter out rows with blank NCO codes
                const validRows = json.filter(item => {
                    const ncoValue = String(item._8DigitNco20152).trim();
                    return ncoValue && ncoValue !== 'undefined' && ncoValue !== '';
                });
                
                const skippedCount = json.length - validRows.length;
                
                if (validRows.length === 0) {
                    setexportloading(false);
                    Swal.fire({
                        icon: 'warning',
                        title: 'No Valid Data',
                        text: 'All rows have blank NCO codes. Please add data to your Excel file and try again.',
                        confirmButtonText: 'OK'
                    });
                    return;
                }
                
                // Clean up undefined values from Excel
                const senddata = validRows.map((item, index) => {
                    const cleanedItem = {};
                    Object.keys(item).forEach(key => {
                        // Replace undefined with empty string
                        cleanedItem[key] = item[key] === undefined ? '' : item[key];
                    });
                    return {
                        ...cleanedItem,
                        _8DigitNco20152: String(cleanedItem._8DigitNco20152),
                        Value: index + Countdata + 1,
                        ParametersID: 57,
                        EmploymentId: employmentId
                    };
                });
                ////console.log(senddata)

        await fetch(
          process.env.REACT_APP_API_LINK + "api/Main/AdddataexelEs3",
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(senddata),
          }
        )
          .then((response) => response.json())
          .then((data) => {
            //console.log(data);
            if (data.length > 0) {
              setexportloading(false);
              getdata();

                // ✅ Show success Swal
                let successMessage = `Successfully imported.`;
                // if (skippedCount > 0) {
                //     successMessage += ` ${skippedCount} row(s) with blank NCO codes were skipped.`;
                // }
                
                Swal.fire({
                    icon: 'success',
                    title: 'Upload Successful!',
                    text: successMessage,
                    showConfirmButton: true,
                    confirmButtonColor: '#3085d6',
                    timer: 4000,
                });
            } else {
              Swal.fire({
                title: "Data Uploaded Failed!!",
                icon: "error",
              });
            }
          });
      };
      reader.readAsArrayBuffer(e.target.files[0]);
    }
  };

  return (
    <React.Fragment>
      <Head title="AllUser" />
      {exportloading ? (
        <div className="loader-container">
          <div className="spinner"></div>
          <div className="message">
            Please wait while we upload the Excel Data and Do not Refresh the
            page ⌛{" "}
          </div>
        </div>
      ) : (
        <Content>
          {loading ? (
            <Spinner color="success" />
          ) : (
            <Block>
              <Button
                onClick={() => (window.location.href = "/Dashboard")}
                color="dark"
              >
                <em className="icon ni ni-back-alt"></em> BACK
              </Button>
              <Card
                className="card-bordered card-stretch"
                style={{ padding: 20 }}
              >
                <Row className="gy-4">
                  <Col md="3">
                    <h3 style={{ marginBottom: 40 }}>
                      Employment Return (ES3){" "}
                    </h3>
                  </Col>
                  <Col md="3">
                    <input
                      style={{ display: "none" }}
                      type="file"
                      name="upload"
                      id="upload"
                      onChange={readUploadFile}
                      ref={inputRef}
                    />

                    {Draft ? null : (
                      <Button style={{ margin: "1.5rem" }} color="success">
                        <Icon className="icon ni ni-arrow-up-circle"></Icon>
                        <b
                          style={{ fontSize: 18 }}
                          onClick={() => handleClick()}
                        >
                          {" "}
                          Import Data from Excel{" "}
                        </b>
                      </Button>
                    )}
                  </Col>
                  <Col md="3">
                    <DownloadTableExcel
                      filename="ES3 Excel Format"
                      sheet="users"
                      currentTableRef={tableRef1.current}
                    >
                      {Draft ? null : (
                        <Button style={{ margin: "1.5rem" }} color="info">
                          <Icon className="icon ni ni-download"></Icon>
                          <b style={{ fontSize: 18 }}>Download Excel Format</b>
                        </Button>
                      )}
                    </DownloadTableExcel>
                  </Col>
                  <Col md="3">
                    <DownloadTableExcel
                      filename="ES3 Edit Report"
                      sheet="users"
                      currentTableRef={tableRef.current}
                    >
                      {Draft ? null : (
                        <Button
                          style={{ float: "right", margin: "1.5rem" }}
                          color="warning"
                        >
                          <Icon className="icon ni ni-download"></Icon>
                          <b style={{ fontSize: 18 }}>Export Excel</b>
                        </Button>
                      )}
                    </DownloadTableExcel>
                  </Col>
                </Row>
                {Draft ? (
                  <Row className="gy-4">
                    <Col md="6">
                      <OptionCDisable
                        onInputChange={onInputChange}
                        namemain="year"
                        mainid="year"
                      />
                    </Col>
                    {Gloading === false ? (
                      <Col md="6">
                        <Button color="success" onClick={() => generate()}>
                          Generate
                        </Button>
                      </Col>
                    ) : (
                      <Spinner color="success" />
                    )}
                  </Row>
                ) : (
                  <Card
                    style={{
                      marginTop: 20,
                      border: "2px solid black",
                      padding: 10,
                    }}
                    className="card-bordered card-stretch"
                  >
                    <Row className="gy-4">
                      <Col md="6">
                        <FormGroup>
                          <label className="form-label" htmlFor="Month">
                            Center:{" "}
                            <label style={{ fontWeight: "normal" }}>
                              {" "}
                              {userData.user !== undefined
                                ? userData.user.state
                                : "Not Specified"}
                            </label>
                          </label>
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup>
                          <label className="form-label" htmlFor="Month">
                            Name of Employment Exchange:{" "}
                            <label style={{ fontWeight: "normal" }}>
                              {" "}
                              {userData.user !== undefined
                                ? userData.user.answer1
                                : "Not Specified"}
                            </label>
                          </label>
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup>
                          <label className="form-label" htmlFor="Month">
                            Month:{" "}
                            <label style={{ fontWeight: "normal" }}>
                              {" "}
                              {month1[userData.monthId]}
                            </label>
                          </label>
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup>
                          <label className="form-label" htmlFor="Month">
                            ES 3: Return showing the work done by the Employment
                            Exchanges by NCO:{" "}
                            <label style={{ fontWeight: "normal" }}> </label>
                          </label>
                        </FormGroup>
                      </Col>
                    </Row>
                    <div
                      className="card-inner-group"
                      style={{ border: "2px solid black", padding: 2 }}
                    >
                      <div
                        style={{
                          height: window.innerHeight - 300,
                          width: "auto",
                          overflow: "scroll",
                        }}
                        className="table-responsive"
                      >
                        <table
                          className="table"
                          style={{
                            borderCollapse: "separate",
                            borderSpacing: 0,
                          }}
                        >
                          <thead
                            style={{
                              position: "-webkit-sticky",
                              position: "sticky",
                              top: 0,
                              backgroundColor: "#edecec",
                            }}
                          >
                            <tr>
                              <th
                                rowSpan="4"
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  verticalAlign: "inherit",
                                }}
                              >
                                S. No.
                              </th>
                              <th
                                rowSpan="4"
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  verticalAlign: "inherit",
                                  minWidth: 150,
                                }}
                              >
                                8 digit NCO-2015
                              </th>
                              <th
                                colSpan="7"
                                rowSpan="3"
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  verticalAlign: "inherit",
                                }}
                              >
                                No of applicants on the Live Register at the end
                                of the month in respect of
                              </th>
                              <th
                                colSpan="28"
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  verticalAlign: "inherit",
                                }}
                              >
                                Number of Vacancies
                              </th>
                            </tr>
                            <tr>
                              <td
                                colSpan="7"
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                }}
                              >
                                {" "}
                                Notified upto the current month
                              </td>
                              <td
                                colSpan="7"
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                }}
                              >
                                {" "}
                                Filled upto the current month
                              </td>
                              <td
                                colSpan="7"
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                }}
                              >
                                {" "}
                                Cancelled upto the current month
                              </td>
                              <td
                                colSpan="7"
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                }}
                              >
                                {" "}
                                Outstanding upto the current month
                              </td>
                            </tr>
                            <tr>
                              <td
                                colSpan="7"
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                }}
                              >
                                {" "}
                                in respect of
                              </td>
                              <td
                                colSpan="7"
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                }}
                              >
                                {" "}
                                in respect of
                              </td>
                              <td
                                colSpan="7"
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                }}
                              >
                                {" "}
                                in respect of
                              </td>
                              <td
                                colSpan="7"
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                }}
                              >
                                {" "}
                                in respect of
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                Total{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                Women
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                Transgender
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                SC{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                ST{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                OBC
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                PWD
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                Total{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                Women
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                Transgender
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                SC{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                ST{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                OBC
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                PWD
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                Total{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                Women
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                Transgender
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                SC{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                ST{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                OBC
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                PWD
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                Total{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                Women
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                Transgender
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                SC{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                ST{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                OBC
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                PWD
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                Total{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                Women
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                Transgender
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                SC{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                ST{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                OBC
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                PWD
                              </td>
                            </tr>
                          </thead>

                          <tbody>
                            {dataactive.length > 0
                              ? dataactive.map((details) =>
                                  details.parentId === 0 ? (
                                    <tr scope="row">
                                      <td>
                                        <b> {details.value}</b>
                                      </td>
                                    </tr>
                                  ) : (
                                    <ES3Update
                                      Change={Change}
                                      value={details.value}
                                      setGTotal={setGTotal}
                                      GTotal={GTotal}
                                      edit={true}
                                      es3detailsId={details.es3detailsId}
                                      employmentId={employmentId}
                                      ES3Update={ES3Update}
                                    />
                                  )
                                )
                              : null}
                            <tr>
                              <Button
                                color="success"
                                onClick={() => ADDDynamic()}
                              >
                                ADD
                              </Button>
                            </tr>
                            <tr scope="row">
                              <td>
                                <b> Total</b>
                              </td>
                              <td></td>
                              {/*<td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall._8DigitNco20152}
                                                        </td>*/}
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.total3}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.women4}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.transgender5}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.sc6}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.st7}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.obc8}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.pwd9}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.tota10}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.women11}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.transgender12}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.sc13}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.st14}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.obc15}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.pwd16}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.total17}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.women18}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.transgender19}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.sc20}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.st21}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.obc22}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.pwd23}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.total24}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.women25}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.transgender26}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.sc27}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.st28}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.obc29}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.pwd30}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.total31}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.women32}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.transgender33}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.sc34}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.st35}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.obc36}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.pwd37}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <div
                        style={{ visibility: "hidden", height: 0, width: 0 }}
                        className="table-responsive"
                      >
                        <table
                          className="table"
                          ref={tableRef}
                          style={{
                            borderCollapse: "separate",
                            borderSpacing: 0,
                          }}
                        >
                          <thead
                            style={{
                              position: "-webkit-sticky",
                              position: "sticky",
                              top: 0,
                              backgroundColor: "#edecec",
                            }}
                          >
                            <tr>
                              <th
                                rowSpan="4"
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  verticalAlign: "inherit",
                                }}
                              >
                                S. No.
                              </th>
                              <th
                                rowSpan="4"
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  verticalAlign: "inherit",
                                  minWidth: 150,
                                }}
                              >
                                8 digit NCO-2015
                              </th>
                              <th
                                colSpan="7"
                                rowSpan="3"
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  verticalAlign: "inherit",
                                }}
                              >
                                No of applicants on the Live Register at the end
                                of the month in respect of
                              </th>
                              <th
                                colSpan="28"
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  verticalAlign: "inherit",
                                }}
                              >
                                Number of Vacancies
                              </th>
                            </tr>
                            <tr>
                              <td
                                colSpan="7"
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                }}
                              >
                                {" "}
                                Notified upto the current month
                              </td>
                              <td
                                colSpan="7"
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                }}
                              >
                                {" "}
                                Filled upto the current month
                              </td>
                              <td
                                colSpan="7"
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                }}
                              >
                                {" "}
                                Cancelled upto the current month
                              </td>
                              <td
                                colSpan="7"
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                }}
                              >
                                {" "}
                                Outstanding upto the current month
                              </td>
                            </tr>
                            <tr>
                              <td
                                colSpan="7"
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                }}
                              >
                                {" "}
                                in respect of
                              </td>
                              <td
                                colSpan="7"
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                }}
                              >
                                {" "}
                                in respect of
                              </td>
                              <td
                                colSpan="7"
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                }}
                              >
                                {" "}
                                in respect of
                              </td>
                              <td
                                colSpan="7"
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                }}
                              >
                                {" "}
                                in respect of
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                Total{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                Women
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                Transgender
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                SC{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                ST{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                OBC
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                PWD
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                Total{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                Women
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                Transgender
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                SC{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                ST{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                OBC
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                PWD
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                Total{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                Women
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                Transgender
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                SC{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                ST{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                OBC
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                PWD
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                Total{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                Women
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                Transgender
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                SC{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                ST{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                OBC
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                PWD
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                Total{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                Women
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                Transgender
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                SC{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                ST{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                OBC
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                PWD
                              </td>
                            </tr>
                          </thead>

                          <tbody>
                            {dataactive.length > 0
                              ? dataactive.map((details) =>
                                  details.parentId === 0 ? (
                                    <tr scope="row">
                                      <td>
                                        <b> {details.value}</b>
                                      </td>
                                    </tr>
                                  ) : (
                                    <ES3Update
                                      Change={Change}
                                      value={details.value}
                                      setGTotal={setGTotal}
                                      GTotal={GTotal}
                                      edit={false}
                                      es3detailsId={details.es3detailsId}
                                      employmentId={employmentId}
                                      ES3Update={ES3Update}
                                    />
                                  )
                                )
                              : null}

                            <tr scope="row">
                              <td>
                                <b> Total</b>
                              </td>
                              <td></td>
                              {/*<td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall._8DigitNco20152}
                                                        </td>*/}
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.total3}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.women4}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.transgender5}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.sc6}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.st7}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.obc8}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.pwd9}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.tota10}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.women11}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.transgender12}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.sc13}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.st14}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.obc15}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.pwd16}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.total17}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.women18}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.transgender19}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.sc20}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.st21}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.obc22}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.pwd23}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.total24}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.women25}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.transgender26}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.sc27}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.st28}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.obc29}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.pwd30}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.total31}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.women32}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.transgender33}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.sc34}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.st35}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.obc36}
                              </td>
                              <td style={{ textAlign: "center", padding: 10 }}>
                                {Totall.pwd37}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      {/*Excel Format*/}
                      <div
                        style={{ visibility: "hidden", height: 0, width: 0 }}
                        className="table-responsive"
                      >
                        <table
                          className="table"
                          ref={tableRef1}
                          style={{
                            borderCollapse: "separate",
                            borderSpacing: 0,
                          }}
                        >
                          <thead
                            style={{
                              position: "-webkit-sticky",
                              position: "sticky",
                              top: 0,
                              backgroundColor: "#edecec",
                            }}
                          >
                            <tr>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  verticalAlign: "inherit",
                                }}
                              >
                                SNO
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              >
                                _8DigitNco20152
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                Total3
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                Women4
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                Transgender5
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                Sc6
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                St7
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                Obc8
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                Pwd9{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                Tota10
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                Women11
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                Transgender12
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                Sc13{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                St14{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                Obc15
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                Pwd16
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                Total17{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                Women18
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                Transgender19
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                Sc20{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                St21{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                Obc22
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                Pwd23
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                Total24{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                Women25
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                Transgender26
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                Sc27{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                St28{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                Obc29
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                Pwd30
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                Total31
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                Women32
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                Transgender33
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                Sc34{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                St35{" "}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                Obc36
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 100,
                                }}
                              >
                                {" "}
                                Pwd37
                              </td>
                            </tr>
                          </thead>

                          <tbody>
                            <tr>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold",
                                  minWidth: 200,
                                }}
                              ></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div style={{ marginTop: 30, marginRight: -10 }}>
                      <Button color="info" onClick={() => onSaveDraft()}>
                        Save As Draft<em className="icon ni ni-unarchive"></em>
                      </Button>{" "}
                      <Button onClick={onFormSubmit} color="success">
                        Submit <em className="icon ni ni-file-check"></em>
                      </Button>{" "}
                      <Button
                        color="warning"
                        onClick={() => onSaveDraftGoBack()}
                      >
                        Save As Draft And Back To Dashboard
                        <em className="icon ni ni-signout"></em>
                      </Button>
                    </div>
                  </Card>
                )}
              </Card>
            </Block>
          )}
        </Content>
      )}
    </React.Fragment>
  );
};

export default ES3DataEdit;
